import { Button, Group } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { useTranslation } from "react-i18next";
import RenewalConfirmButton from "./renewalConfirmButton";
import RenewalRejectButton from "./renewalRejectButton";
import PrintCancelNoticeButton from "./renewalPrintCancelNoticeButton";
import RenewalDeliveryButton from "./renewalDeliveryButton";
import RenewalReceivedButton from "./renewalReceiveButton";
import ActionPermissionGate from "./actionPermissionGate";
import { openFileUrl } from "../utils/openReport";

const PrintButton = ({
  mainForm,
  format = "pdf",
  label = "Download Renewal Notice (PDF)",
  disabled = false,
}) => {
  const [api] = useServerApi();
  const [printing, setPrinting] = useState(false);
  const { t: translate } = useTranslation();

  const print = async () => {
    try {
      const { _id } = mainForm.values;
      if (!_id) return;
      await mainForm.save();

      setPrinting(true);
      const result = await api.Renewal.print(_id, format);
      setPrinting(false);

      if (!result || !result.data || !result.data.url) return;
      await openFileUrl(result.data.url);
    } catch (error) {
      console.log(error);
      setPrinting(false);
    }
  };

  return (
    <Button
      fullWidth
      onClick={() => print()}
      loading={printing}
      disabled={disabled || !mainForm.values._id}
    >
      {printing ? "Printing" : translate(label)}
    </Button>
  );
};

const RenewalActionList = ({ form }) => {
  const { status } = form.values;

  const showTerminate = status !== "TERMINATE";
  const showDelivery = status !== "TERMINATE";
  const showPrintCancel = status === "TERMINATE";

  return (
    <>
      {status && (
        <Group mt={10}>
          <ActionPermissionGate
            entity="renewal"
            action="printPdf"
            requireFullAccess={false}
          >
            <PrintButton
              mainForm={form}
              format="pdf"
              label="Download Renewal Notice (PDF)"
            />
          </ActionPermissionGate>
          <ActionPermissionGate
            entity="renewal"
            action="printWord"
            requireFullAccess={false}
          >
            <PrintButton
              mainForm={form}
              format="word"
              label="Download Renewal Notice (Word)"
            />
          </ActionPermissionGate>
          <ActionPermissionGate entity="renewal" action="confirmRenewal">
            <RenewalConfirmButton mainForm={form} />
          </ActionPermissionGate>
          <ActionPermissionGate entity="renewal" action="receiveRenewal">
            <RenewalReceivedButton mainForm={form} />
          </ActionPermissionGate>
          {showDelivery && (
            <ActionPermissionGate entity="renewal" action="deliverRenewal">
              <RenewalDeliveryButton mainForm={form} />
            </ActionPermissionGate>
          )}
          {showPrintCancel && (
            <ActionPermissionGate
              entity="renewal"
              action="printCancelNotice"
              requireFullAccess={false}
            >
              <PrintCancelNoticeButton mainForm={form} />
            </ActionPermissionGate>
          )}
          {showTerminate && (
            <ActionPermissionGate entity="renewal" action="rejectRenewal">
              <RenewalRejectButton mainForm={form} />
            </ActionPermissionGate>
          )}
        </Group>
      )}
    </>
  );
};

export default RenewalActionList;
